// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__r1ThK","rightSide":"profile_rightSide__UErT7","leftSide":"profile_leftSide__PHz+A"};